import "../styles/globals.css";
import "../styles/autocomplete-fixes.css";
import { ThemeProvider } from "next-themes";
import Meta from "../components/Meta";
import MainLayout from "../components/layout";
import { Provider } from "react-redux";
import store from "../store";
import { useRouter } from "next/router";
import UserContext from "../components/UserContext";
import { useRef } from "react";
import {App, ConfigProvider} from 'antd';
import { useEffect, useState } from "react";
import Modal from "react-modal";
import * as Sentry from "@sentry/react";
import "../components/createjobskillselect.css";
import mixpanel from "mixpanel-browser";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

require("dotenv").config({ path: "../.env.local" });
const useBodyBackgroundColor = (color) => {
  useEffect(() => {
    document.body.style.backgroundColor = color;
    return () => {
      document.body.style.backgroundColor = "";
    };
  }, [color]);
};

if (typeof window !== "undefined") {
  require("bootstrap/dist/js/bootstrap");
}



mixpanel.init('110a57d433f78a6aa34811db2535ee2c', {debug: false, track_pageview: true, persistence: 'localStorage',ignore_dnt:true});



Sentry.init({
  debug: false, // Disable in development to reduce noise
  dsn: "https://44f28afbdcbfd98b6c7e94f7c94b8c13@o4505906273583104.ingest.sentry.io/4505906275745792",
  environment: process.env.NODE_ENV,
  release: "synthiahire@" + (process.env.npm_package_version || "1.0.0"),
  integrations: [
    new Sentry.BrowserTracing({
      tracePropagationTargets: [/^https:\/\/synthiahire\.ai\/api/],
    }),
    // PERF: Sentry Replay DISABLED — it records all DOM mutations, network requests,
    // and console logs indefinitely. Over long sessions (19+ hours), this accumulates
    // hundreds of MB of memory with no upper bound, causing JS heap to grow to 1782MB.
    // new Sentry.Replay({ maskAllText: false, blockAllMedia: false }),
  ],
  tracesSampleRate: process.env.NODE_ENV === "production" ? 0.1 : 0,
  replaysSessionSampleRate: 0,
  replaysOnErrorSampleRate: 0,
  beforeSend(event, hint) {
    // Don't send events from localhost
    if (event.request?.url?.includes("localhost")) {
      return null;
    }
    return event;
  },
});

function MyApp({ Component, pageProps }) {
  const [guidedTourActive, setGuidedTourActive] = useState(false);

  const router = useRouter();
  const pid = router.asPath;
  const scrollRef = useRef({
    scrollPos: 0,
  });

  const getLayout = Component.getLayout || ((page) => <MainLayout>{page}</MainLayout>)
  useEffect(() => {
    // Set the app element to the root element of your app
    Modal.setAppElement("#__next"); // Replace '#__next' with the actual ID of your app's root element
  }, []);

  useBodyBackgroundColor(guidedTourActive ? "rgba(0, 0, 0, 0.5)" : "#fff");
  return (
    <>
      <Meta/>
      <ToastContainer
        pauseOnHover={false}
        pauseOnFocusLoss={false}
        style={{ zIndex: 99999 }}
      />
      <App>
      <Provider store={store}>
        {/* <PersistGate persistor={persistor}> */}
        {/* <ThemeProvider enableSystem={true} attribute="class"> */}
          <UserContext.Provider value={{ scrollRef: scrollRef }}>
            {pid === "/login" ? (
              <Component {...pageProps} />
            ) : (

              <ConfigProvider theme={{token:{borderRadius:0,colorPrimary:"#8358ff"}}}>
                {getLayout(<Component {...pageProps} />)}
              </ConfigProvider>
            )}
          </UserContext.Provider>
        {/* </ThemeProvider> */}
        {/* </PersistGate> */}
      </Provider>
      </App>
    </>
  );
}

export default MyApp;
